import { createRoot } from 'react-dom/client'
import './index.css'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n/i18n.ts'
import { AppConfigProvider } from '@kf-react/config'
import { ApplicationConfig } from './core/domain/app.config';
import { SecurityProvider } from './providers/SecurityProvider.tsx'




createRoot(document.getElementById('root')!).render(
  <AppConfigProvider<ApplicationConfig>>
    <I18nextProvider i18n={i18n}>
       <SecurityProvider />
    </I18nextProvider>
  </AppConfigProvider>
)
